module.exports = __webpack_public_path__ + "static/img/shanchu2.44d1c33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/shanchu2.png
// module id = OIIB
// module chunks = 24